import { type NavItem, Sidebar as UISidebar } from '@quadralize/ui'
import { useAuthStore } from '@quadralize/utils'
import { Buildings2, Flag, UserId, Widget } from '@solar-icons/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { usePwaUpdate } from '@/hooks/use-pwa-update'
import { useAppStore } from '@/stores/use-app-store'

interface SidebarProps {
  className?: string
  isMobile?: boolean
  onClose?: () => void
}

export function Sidebar({ className, isMobile, onClose }: SidebarProps) {
  const { t } = useTranslation('layout')
  const navigate = useNavigate()
  const { setSidebarOpen, isSidebarCollapsed, toggleSidebarCollapsed } = useAppStore()
  const { logout } = useAuthStore()
  const { needRefresh, updateServiceWorker } = usePwaUpdate()

  const navItems: NavItem[] = [
    { label: t('navigation.dashboard'), icon: Widget, path: '/' },
    { label: t('navigation.companies'), icon: Buildings2, path: '/empresas' },
    { label: t('navigation.origins'), icon: Flag, path: '/origens' },
    { label: t('navigation.users'), icon: UserId, path: '/usuarios' },
  ]

  const currentPath = window.location.pathname

  const handleNavigate = (path: string) => {
    navigate(path)
    if (isMobile) {
      setSidebarOpen(false)
      onClose?.()
    }
  }

  return (
    <UISidebar
      className={className}
      isMobile={isMobile}
      isCollapsed={isSidebarCollapsed}
      onToggleCollapse={toggleSidebarCollapsed}
      currentPath={currentPath}
      items={navItems}
      onNavigate={handleNavigate}
      onClose={onClose}
      onSignOut={logout}
      isSignOutLoading={false}
      onUpdate={() => updateServiceWorker(true)}
      isUpdateAvailable={needRefresh}
      logo={{
        text: t('shell.title'),
        imageSrc: '/logo.svg',
      }}
    />
  )
}
